export function normalizeSongTitle(title) {
    return (title || '').normalize('NFC').replace(/\s+/g, '').toUpperCase();
}

// Keep aliases on the original song record so remakes retain their own artwork and links.
export function resolveSong(songs, title) {
    const titleKey = normalizeSongTitle(title === '폴라로이드' ? 'POLAROID' : title);
    if (songs[titleKey]) {
        return { key: titleKey, song: songs[titleKey] };
    }
    const match = Object.entries(songs).find(([, song]) =>
        (song.aliases || []).some(alias => normalizeSongTitle(alias) === titleKey)
    );
    return match ? { key: match[0], song: match[1] } : { key: titleKey, song: undefined };
}

export function songThumbnailUrl(titleKey) {
    const encoded = btoa(unescape(encodeURIComponent(titleKey))).replace(/\//g, '_');
    return `https://cdn.hero-chart.kr/images_new/${encoded}.jpg`;
}
